import type { Components } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

export const MuiIconButton = (theme: Theme): Components => ({
  MuiIconButton: {
    styleOverrides: {
      root: {
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 11,
        borderRadius: '50%',
        overflow: 'visible',
        fill: theme.palette.grey[800],
        color: theme.palette.grey[800],
        '&:hover': {
          backgroundColor: theme.palette.grey[200],
          '@media (hover: none)': {
            backgroundColor: 'transparent',
          },
        },
        '&:active': {
          backgroundColor: theme.palette.grey[400],
        },
        '&$disabled': {
          backgroundColor: 'transparent',
          fill: theme.palette.grey[400],
          color: theme.palette.grey[400],
        },
      },
      edgeStart: {
        marginLeft: -12,
        '$sizeSmall&': {
          marginLeft: -3,
        },
      },
      edgeEnd: {
        marginRight: -12,
        '$sizeSmall&': {
          marginRight: -3,
        },
      },
      colorInherit: {
        fill: 'inherit',
        color: 'inherit',
      },
      colorPrimary: {
        fill: theme.palette.primary.main,
        color: theme.palette.primary.main,
      },
      colorSecondary: {
        fill: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
      },
      sizeSmall: {
        padding: 8,
        fontSize: theme.typography.pxToRem(16),
      },
    },
    defaultProps: {
      disableTouchRipple: true,
    },
  },
});
